
























































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbGoods } from '@/http';
import dayjs from "dayjs";
import { fmoney } from '@/common/money';
import { tailFun } from "@/common/util/tail";
import { Toast } from 'vant';
@Component({
    components: {
        
    },
})
export default class selectProduct extends Vue {

    @Prop({
        default:false
    })
    isshowPop:Boolean;
    public $refs: {
    };
    fmoney=fmoney;
    tailFun =tailFun;
    show = false;

    list = [];
    form = {};

    activeId = "";
    
    created() {
    }
    mounted() {
    }

    async showFun(id){
        let res = await TbGoods.GetTbGoodsById({id:id});
        console.log('res',res);
        this.form = res;
        this.list = res.getGoodsItemsList?res.getGoodsItemsList.map(v=>{
            return {
                ...v,
                num:0
            }
        }):[];
        this.show = true;
    }
    closeFun(){
        this.show = false;
    }
    //批量减少
    plminus(){
        this.list = this.list.map(v=>{
            return {
                ...v,
                num:Number(v.num-1)<=0?0:v.num - 1
            }
        })
    }
    //批量添加
    pladd(){
        this.list = this.list.map(v=>{
            return {
                ...v,
                num:v.num+1
            }
        })
    }
    //单个减少
    singleMinus(index){
        this.$set(this.list[index], "num", this.list[index].num - 1<=0?0:this.list[index].num - 1);
    }
    //单个添加
    singleAdd(index){
        this.$set(this.list[index], "num", this.list[index].num +1);
    }
    addItem(){
        if(this.getNum()==0) {
            Toast('调拨数量不可为0');
            return;
        }
        let arr = []
        arr = this.list.filter(v=>v.num>0).map(v=>{
            return {
                ...v,
                // 规格上可能无 goodsId，用商品主档 id 兜底，保证种类计数准确
                goodsId:v.goodsId || this.form['id'],
                goodsItemsId:v.id,
                price:this.form['sellingPrice'],
                articleNo:this.form['articleNo'],
                name:this.form['name'],
                goodsImgUrl:this.form['goodsImgUrl']
            }
        })
        this.$emit('chooseFun',arr);
        this.show = false;
    }
    //计算数量
    getNum(){
        let num = 0;
        let arr = this.list.filter((v) => Number(v.num) > 0).map((v) => v.num);
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        return Number(num);
    }
    //计算总额
    getTotal() {
        let num = 0;
        let arr = this.list.filter((v) => Number(v.num) > 0).map(v=>v.num*this.form['sellingPrice']);
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number(tailFun(Number(n) + Number(m), 2)));
        }
        return Number(num);
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/components/selectProduct.vue